import React, { useState, useEffect } from 'react';
import { Box, Typography, Button, Link, Paper } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const CONSENT_KEY = 'cookie_consent';

const CookieBanner = () => {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(CONSENT_KEY)) setVisible(true);
  }, []);

  const accept = () => { localStorage.setItem(CONSENT_KEY, 'accepted'); setVisible(false); };
  const reject = () => { localStorage.setItem(CONSENT_KEY, 'rejected'); setVisible(false); };

  if (!visible) return null;

  return (
    <Paper
      elevation={8}
      sx={{
        position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 9999,
        p: { xs: 2, sm: 3 },
        borderRadius: 0,
        borderTop: '3px solid #951520',
        backgroundColor: '#1a1a1a',
      }}
    >
      <Box sx={{ maxWidth: 'lg', mx: 'auto', display: 'flex', flexDirection: { xs: 'column', md: 'row' }, alignItems: { md: 'center' }, gap: 2 }}>
        <Typography variant="body2" sx={{ color: 'white', flex: 1, lineHeight: 1.6 }}>
          {t('cookie.text')}{' '}
          <Link component={RouterLink} to="/cookie-policy" sx={{ color: '#f0a0a0' }}>
            {t('cookie.policy')}
          </Link>{' '}{t('cookie.and')}{' '}
          <Link component={RouterLink} to="/privacy-policy" sx={{ color: '#f0a0a0' }}>
            {t('cookie.privacy')}
          </Link>.
        </Typography>
        <Box sx={{ display: 'flex', gap: 1.5, flexShrink: 0, flexDirection: { xs: 'column', sm: 'row' } }}>
          <Button
            onClick={reject}
            variant="outlined"
            size="small"
            sx={{
              color: 'white', borderColor: 'white', minWidth: 110,
              '&:hover': { borderColor: 'white', backgroundColor: 'rgba(255,255,255,0.08)' },
            }}
          >
            {t('cookie.reject')}
          </Button>
          <Button
            onClick={accept}
            variant="contained"
            size="small"
            sx={{ backgroundColor: '#951520', minWidth: 110, '&:hover': { backgroundColor: '#7a1018' } }}
          >
            {t('cookie.accept')}
          </Button>
        </Box>
      </Box>
    </Paper>
  );
};

export default CookieBanner;
